<div class="checkout-group">
  <div #orderType class="checkout-group-title">
    @if (!addressSelectionActive) {
    {{ 'checkout.group.shipping.title' | cxTranslate }}
    } @if (addressSelectionActive) {
    {{ 'checkout.group.shipping.changeTitle' | cxTranslate }}
    } @if (!addressSelectionActive && !canContinue && isChangeDeliveryAddressEnabled$ | async) {
    <span class="checkout-shipping-change js-checkout-shipping-change" (click)="changeAddressSection()">{{
      'checkout.group.shipping.action' | cxTranslate
    }}</span>
    }
  </div>
  <div class="checkout-group-body">
    <div class="address-group">
      <div class="address-section" [ngClass]="addressSelectionActive ? 'dropdownActivated' : ''">
        <span class="address-label">{{ 'checkout.group.shipping.addressLabel' | cxTranslate }}</span>
        @if (this.deliveryAddress) {
        <span class="address-value" [innerHTML]="showAddress(this.deliveryAddress) | async"></span>
        }
      </div>
      <div class="address-section" [ngClass]="addressSelectionActive === false ? 'dropdownNotActivated' : ''">
        <form [formGroup]="currentAddress">
          @for (address of allShippingAddresses; track address; let first = $first) {
          <div>
            @if (address !== undefined) {
            <div
              class="custom-control custom-radio"
              [ngClass]="{
                'first-list': first
              }"
            >
              @if (address?.defaultAddress) {
              <span class="default-flag" [innerHTML]="'checkout.group.shipping.defaultFlag' | cxTranslate"></span>
              }
              <input
                [id]="address?.id"
                type="radio"
                class="custom-control-input js-shipping-selection"
                [value]="address?.id"
                name="addressId"
                formControlName="addressId"
                [checked]="idSelector(radioSelector, deliveryAddress?.addressId) == address?.addressId ? true : false"
              />
              <label
                class="custom-control-label"
                [ngClass]="{ 'default-label': address?.defaultAddress }"
                [for]="address?.id"
                [innerHTML]="showAddress(address) | async"
              ></label>
            </div>
            }
            <hr />
          </div>
          }
          <hr class="hr-footer" />
          <div class="radio-submit-buttons">
            <button (click)="onCancel()" class="secondary-btn btn-block btn mw-160-lg shipping-btn">
              {{ 'checkout.group.shipping.cancel' | cxTranslate }}
            </button>
            <button
              (click)="onSubmit()"
              class="primary-btn btn-block btn mw-160-lg shipping-btn"
              [disabled]="isButtonDisabled"
              [ngClass]="{
                rotating: isButtonLoading
              }"
            >
              {{ isButtonDisabled && isButtonLoading ? '' : ('checkout.group.shipping.save' | cxTranslate) }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
